module.exports = __webpack_public_path__ + "static/media/pro-saber.a77ad408.JPG";